import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useTranslation } from 'react-i18next';

export function Bezahlungsart() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const data = form.state.values;

  return (
    <div className="py-2 grid grid-cols-2 gap-y-4 text-neutrals-800 leading-5 text-sm font-normal">
      <span>
        {t(
          'domain.mitarbeiter.create.steps.bezahlung.bezahlungsart.form.art.label',
        )}
      </span>
      <span className="text-neutrals-900 font-semibold">
        {t(
          'domain.mitarbeiter.create.steps.bezahlung.bezahlungsart.form.art.options.' +
            data.bezahlung.bezahlungsart.art,
        )}
      </span>
      <span>
        {t(
          'domain.mitarbeiter.create.steps.bezahlung.bezahlungsart.verguetung.title',
        )}
      </span>
      <div className="flex flex-col">
        <span className="text-neutrals-900 font-semibold">
          {`${data.bezahlung.bezahlungsart.stundenlohn ?? '-'} €/Std.`}
        </span>

        <span className="text-neutrals-900 font-semibold">
          {`${data.bezahlung.bezahlungsart.monatsgehalt ?? '-'} €/Monat`}
        </span>
      </div>
    </div>
  );
}
